export const SOFTGAMING_PROVIDERS = [
  'pgsoft',
  'platipus',
  'upgaming',
  'evosw',
  'bgaming',
  'spinomenal',
  'onlyplay',
  'originalgames',
  'betsoft',
  'endorphina',
  'yggdrasil',
  'habanero',
  'spadegaming',
]
